/*
 * sa-facets.js
 *
 * Ported from orion-v3.0's assets/sa-facets.js. Provides:
 *   - jQuery-based popup open/close + accordion behaviour
 *   - <facet-filters-form> / <price-range> / <facet-remove>
 *     custom elements with the enhanced tab-aware behaviour the
 *     SA Collection Filters tabs system depends on (combined search
 *     params across the tab form + the sort form, dual-target re-
 *     render of #product-grid-container AND .collection-filter-tabs).
 *
 * H3.0 adaptations:
 *   - menu-drawer.bindEvents() call guarded with optional chaining —
 *     H3.0 has no <menu-drawer> element on the collection template.
 *   - customElements.define wrapped in `if (!customElements.get(...))`
 *     so re-registration during HMR / live reload doesn't throw.
 *   - Extra null guards around ProductCount / collection elements
 *     so initial render on an empty collection doesn't crash.
 *
 * Depends on jQuery being available globally (it is in H3.0 via the
 * existing theme bundle).
 */

function debounceFacets(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/* Read --global-transition-duration off :root and convert to ms so
 * jQuery .slideUp() / .slideDown() can use the same duration the
 * rest of the theme transitions on (Theme Settings → Animation
 * Transition). Falls back to 300ms if the var is missing or
 * unreadable. */
function getSlideDuration() {
  try {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--global-transition-duration').trim();
    if (raw.endsWith('ms')) return parseFloat(raw);
    if (raw.endsWith('s')) return parseFloat(raw) * 1000;
  } catch (e) {}
  return 300;
}

document.addEventListener('DOMContentLoaded', function () {
  const slideDuration = getSlideDuration();

  // Open and close filter popup
  $(document).on('click', '.js-filters-popup__open', function (e) {
    e.preventDefault();
    e.stopPropagation();

    $('body').addClass('filters-popup--show');

    // Close all accordion contents
    $('.collection-filter__accordion-content').removeClass('is-active').slideUp(slideDuration);
    $('.collection-filter__accordion-header').removeClass('is-active');
  });

  $(document).on('click', '.js-filters-popup__close', function (e) {
    e.preventDefault();
    $('body').removeClass('filters-popup--show');
  });

  $(document).on(
    'click',
    '.filters-popup__overlay, .collection-filter__overlay',
    function () {
      $('body').removeClass('filters-popup--show');
    }
  );

  $(document).on('click', '.filters-popup, .collection-filter', function (e) {
    e.stopPropagation();
  });

  // Sync checkboxes between both forms (tab form + popup form)
  $(document).on(
    'change',
    'input[name="filter.p.m.custom.filter_product_type"]',
    function () {
      const value = $(this).val();
      const isChecked = $(this).is(':checked');

      $(`input[name="filter.p.m.custom.filter_product_type"][value="${value}"]`)
        .not(this)
        .prop('checked', isChecked);

      // "All" filter exclusivity logic
      if (value === 'all' && isChecked) {
        $('input[name="filter.p.m.custom.filter_product_type"]')
          .not('[value="all"]')
          .prop('checked', false);
      } else if (value !== 'all' && isChecked) {
        $('input[name="filter.p.m.custom.filter_product_type"][value="all"]').prop('checked', false);
      }
    }
  );

  $(document).on(
    'change',
    'input[value="all"][name="filter.p.m.custom.filter_product_type"]',
    function () {
      if ($(this).is(':checked')) {
        $('input[name="filter.p.m.custom.filter_product_type"]')
          .not(this)
          .prop('checked', false)
          .trigger('change');
      }
    }
  );

  function updateApplyCount() {
    const total = $('.filters-popup input:checked').length;
    $('.js-filters-popup-apply-count').text(total > 0 ? '(' + total + ')' : '');
  }

  // Update selected count in accordion header on checkbox change
  $(document).on('change', '.collection-filter__accordion-content input[type="checkbox"]', function () {
    const $accordion = $(this).closest('.collection-filter__accordion');
    const $header = $accordion.find('.collection-filter__accordion-header');
    const count = $accordion.find('.collection-filter__accordion-content input[type="checkbox"]:checked').length;
    let $count = $header.find('.filter-group__selected-count');

    if (count > 0) {
      if ($count.length === 0) {
        $count = $('<span class="filter-group__selected-count"></span>');
        $header.find('.filter-group__arrow').before($count);
      }
      $count.text('(' + count + ' selected)');
    } else {
      $count.remove();
    }

    updateApplyCount();
  });

  updateApplyCount();

  $(document).on('change', '.filter-item--swatch .swatch-input__input', function () {
    $(this).closest('.filter-item--swatch').toggleClass('active', this.checked);
  });

  // Accordion functionality
  $(document).on('click', '.collection-filter__accordion-header', function (e) {
    e.preventDefault();
    const $accordion = $(this).closest('.collection-filter__accordion');
    const $content = $accordion.find('.collection-filter__accordion-content');
    const isActive = $content.hasClass('is-active');

    $('.collection-filter__accordion-content').not($content).removeClass('is-active').slideUp(slideDuration);
    $('.collection-filter__accordion-header').not($(this)).removeClass('is-active');

    if (isActive) {
      $content.removeClass('is-active').slideUp(slideDuration);
      $(this).removeClass('is-active');
    } else {
      $content.addClass('is-active').slideDown(slideDuration);
      $(this).addClass('is-active');
    }
  });
});

function onKeyUpEscapeSA(event) {
  if (event.code && event.code.toUpperCase() === 'ESCAPE') {
    const open = event.target.closest('details[open]');
    if (!open) return;
    open.removeAttribute('open');
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounceFacets((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscapeSA);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.body.classList.add('sa-facets--loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const productGridContainer = document.getElementById('product-grid-container');
    const parsedProductGrid = parsedHTML.getElementById('product-grid-container');
    if (productGridContainer && parsedProductGrid) {
      productGridContainer.innerHTML = parsedProductGrid.innerHTML;

      /* Re-init Ajaxinate's Load More on the freshly-replaced
       * #product-grid. The original instance bound in
       * snippets/ajaxinate.liquid was tied to the old DOM element,
       * which is now gone — without this re-init, the next
       * Load-More click falls back to native <a> navigation and
       * the page reloads, losing the AJAX state.
       *
       * Destroys any prior endlessScroll instance first so we
       * don't accumulate listeners across successive filter / sort
       * changes. */
      if (typeof Ajaxinate !== 'undefined' && document.querySelector('#product-grid') && document.querySelector('#AjaxinatePagination')) {
        if (window.endlessScroll) {
          try { window.endlessScroll.destroy(); } catch (e) {}
        }
        window.endlessScroll = new Ajaxinate({
          container: '#product-grid',
          method: 'click',
          callback: function (data) {
            document.body.classList.remove('ajaxinate--loading');
            if (typeof ajaxinateCallback === 'function') ajaxinateCallback();
            try {
              const params = new URL(data.URL).searchParams;
              const page = params.get('page');
              if (page) {
                const newUrl = new URL(window.location.href);
                newUrl.hash = 'page-' + page;
                history.replaceState(history.state, '', newUrl.toString());
              }
            } catch (e) {}
          },
        });
      }
    }

    const collectionFilterTabs = document.querySelector('.collection-filter-tabs');
    const parsedFilterTabs = parsedHTML.querySelector('.collection-filter-tabs');
    if (collectionFilterTabs && parsedFilterTabs) {
      collectionFilterTabs.innerHTML = parsedFilterTabs.innerHTML;
    }

    document.body.classList.remove('sa-facets--loading');

    if (window.indentGridProducts) {
      indentGridProducts();
    }
  }

  static renderProductCount(html) {
    const parsedDoc = new DOMParser().parseFromString(html, 'text/html');
    const sourceCount = parsedDoc?.getElementById('ProductCount');
    const count = sourceCount ? sourceCount.innerHTML : '';
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) container.innerHTML = count;

    $('.js-filters-count').html(count);

    document.body.classList.remove('sa-facets--loading');

    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      document.body.classList.remove('sa-facets--loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, #CollectionFilterTabsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
        targetElement.classList.remove('active');
      }

      window?.initFiltersSwiper?.();
      const filtersCount = $('.filters-popup input:checked').length;

      $('.js-filters-applied').text(filtersCount > 0 ? `(${filtersCount})` : '');
      $('.applied-count, .collection-filter-tabs__filters-btn--remove').toggleClass(
        'active',
        filtersCount > 0
      );
      $('.js-filters-popup-apply-count').text(filtersCount > 0 ? '(' + filtersCount + ')' : '');
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = document.querySelector(selector);
      if (target) target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const sourceEl = html.querySelector(selector);
      if (!sourceEl) return;
      const targetEl = document.querySelector(selector);
      if (targetEl) targetEl.innerHTML = sourceEl.innerHTML;
    });

    // H3.0 has no <menu-drawer> custom element; guard the legacy call.
    document.getElementById('FacetFiltersFormMobile')?.closest('menu-drawer')?.bindEvents?.();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const sections = [];
    const grid = document.getElementById('product-grid');
    if (grid) sections.push({ section: grid.dataset.id });
    const tabs = document.querySelector('.collection-filter-tabs');
    if (tabs && tabs.dataset.sectionId) sections.push({ section: tabs.dataset.sectionId });
    return sections;
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (let [key, value] of formData.entries()) {
      if (value && value.trim() !== '') {
        params.append(key, value);
      }
    }

    return params.toString();
  }

  createCombinedSearchParams(forms) {
    const allParams = new URLSearchParams();
    const processedKeys = new Set();

    forms.forEach((form) => {
      const formData = new FormData(form);

      for (let [key, value] of formData.entries()) {
        if (!value || value.trim() === '') continue;

        if (key === 'filter.p.m.custom.filter_product_type') {
          if (!processedKeys.has(`${key}:${value}`)) {
            allParams.append(key, value);
            processedKeys.add(`${key}:${value}`);
          }
        } else {
          allParams.append(key, value);
        }
      }
    });

    return allParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const triggeringForm = event.target.closest('form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(triggeringForm);
      this.onSubmitForm(searchParams, event);
      return;
    }

    if (triggeringForm.id === 'CollectionFilterTabsForm' || triggeringForm.id === 'FacetFiltersForm') {
      const searchParams = this.createSearchParams(triggeringForm);
      this.onSubmitForm(searchParams, event);
      return;
    }

    const forms = [];
    const isMobile = triggeringForm.id === 'FacetFiltersFormMobile';
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(form);
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(form);
      }
    });

    const searchParams = this.createCombinedSearchParams(forms);
    this.onSubmitForm(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
if (!customElements.get('facet-filters-form')) {
  customElements.define('facet-filters-form', FacetFiltersForm);
  FacetFiltersForm.setListeners();
}

class PriceRange extends HTMLElement {
  connectedCallback() {
    this.rangeMin = this.querySelector('.facets__price-range--min');
    this.rangeMax = this.querySelector('.facets__price-range--max');
    this.textInputs = this.querySelectorAll('.facets__price-input');
    this.minInput = this.textInputs[0];
    this.maxInput = this.textInputs[1];

    if (this.rangeMin && this.rangeMax) {
      this.rangeMin.addEventListener('input', this.onSliderInput.bind(this));
      this.rangeMax.addEventListener('input', this.onSliderInput.bind(this));
      this.rangeMin.addEventListener('change', this.onSliderChange.bind(this));
      this.rangeMax.addEventListener('change', this.onSliderChange.bind(this));
    }

    this.textInputs.forEach((el) => {
      el.addEventListener('change', this.onTextChange.bind(this));
      el.addEventListener('keydown', this.onKeyDown.bind(this));
    });

    this.setMinAndMaxValues();
  }

  onSliderInput() {
    let minVal = Number(this.rangeMin.value);
    let maxVal = Number(this.rangeMax.value);
    if (minVal > maxVal) {
      [minVal, maxVal] = [maxVal, minVal];
    }
    if (this.minInput) this.minInput.value = minVal;
    if (this.maxInput) this.maxInput.value = maxVal;
  }

  onSliderChange() {
    this.onSliderInput();
    this.setMinAndMaxValues();
  }

  onTextChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
    if (this.rangeMin && this.minInput) {
      this.rangeMin.value = this.minInput.value || 0;
    }
    if (this.rangeMax && this.maxInput) {
      this.rangeMax.value = this.maxInput.value || this.rangeMax.max;
    }
  }

  onKeyDown(event) {
    if (event.metaKey || event.ctrlKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    if (!this.minInput || !this.maxInput) return;
    if (this.maxInput.value) this.minInput.setAttribute('data-max', this.maxInput.value);
    if (this.minInput.value) this.maxInput.setAttribute('data-min', this.minInput.value);
    if (this.minInput.value === '') this.maxInput.setAttribute('data-min', 0);
    if (this.maxInput.value === '') this.minInput.setAttribute('data-max', this.minInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

if (!customElements.get('price-range')) {
  customElements.define('price-range', PriceRange);
}

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    if (!facetLink) return;
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form && typeof form.onActiveFilterClick === 'function') form.onActiveFilterClick(event);
  }
}

if (!customElements.get('facet-remove')) {
  customElements.define('facet-remove', FacetRemove);
}

/* Product / Lookbook view toggle */
$(document).on('click', '.collection-filter-tabs__view-btn', function () {
  var $btn = $(this);
  if ($btn.hasClass('collection-filter-tabs__view-btn--active')) return;

  $('.collection-filter-tabs__view-btn').removeClass('collection-filter-tabs__view-btn--active');
  $btn.addClass('collection-filter-tabs__view-btn--active');

  var view = $btn.data('view');
  var $grid = $('#product-grid-container');

  if (view === 'lookbook') {
    $grid.addClass('collection-view--lookbook');
  } else {
    $grid.removeClass('collection-view--lookbook');
  }
});
